import vendorsApplicationsList from "./vendorsApplicationsList";
import vendorsLoansList from "./vendorsLoansList";

export default {
  applist: vendorsApplicationsList,
  loanlist: vendorsLoansList,
};
